import type { AttackDefinition } from '../../data/types';
import { FULL_ATTACKS } from '../full';
import { aura } from './aura';
import { straight } from './straight';
import type { AttackModule, AttackModules, Upgraded } from './types';

export const ATTACKS: AttackModules = { straight, aura, ...FULL_ATTACKS };

const NO_UPGRADE: Upgraded = { modifiers: {} };

export function attackModule(attack: AttackDefinition): AttackModule<AttackDefinition> {
  return ATTACKS[attack.kind];
}

export function attackReach(attack: AttackDefinition, player: Upgraded = NO_UPGRADE): number {
  return attackModule(attack).reach(attack, player);
}
